import styles from '../RmCard.module.scss';
import PropTypes from 'prop-types';
import { RMCardGroupDataType } from 'types/types';

const EmergingRmsTooltip = (props) => {
    const { data, dataType } = props;
    const nextThreshold =
        dataType === RMCardGroupDataType.TopFiveEmergingMajorRm
            ? data.majorThreshold
            : data.moderateThreshold + 1;
    return (
        <>
            <div className={styles.textContainer}>
                <span className={styles.statsTitle}>CTO Code</span>
                <span className={styles.statsValue}>{data.rm}</span>
            </div>

            <div className={styles.textContainer}>
                <span className={styles.statsTitle}>Team</span>
                <span className={styles.statsValue}>{data.group}</span>
            </div>

            <div className={styles.textContainer}>
                <span className={styles.statsTitle}>Market</span>
                <span className={styles.statsValue}>{data.region}</span>
            </div>

            <div className={styles.textContainer}>
                <span className={styles.statsTitle}>Rank</span>
                <span className={styles.statsValue}>{data.rank}</span>
            </div>

            <div className={styles.textContainer}>
                <span className={styles.statsTitle}>Risk Score</span>
                <span className={styles.statsValue}>{data.endMonthScore}</span>
            </div>

            <div className={styles.textContainer}>
                <span className={styles.statsTitle}>Next Threshold</span>
                <span className={styles.statsValue}>{nextThreshold}</span>
            </div>

            <div className={styles.textContainer}>
                <span className={styles.statsTitle}>Difference</span>
                <span className={styles.statsValue}>
                    {nextThreshold - data.endMonthScore}
                </span>
            </div>
        </>
    );
};

EmergingRmsTooltip.propTypes = {
    data: PropTypes.shape({
        region: PropTypes.string,
        group: PropTypes.string,
        rm: PropTypes.string,
        spike: PropTypes.number,
        startMonthScore: PropTypes.number,
        endMonthScore: PropTypes.number,
        rank: PropTypes.number,
        moderateThreshold: PropTypes.number,
        majorThreshold: PropTypes.number
    }),
    dataType: PropTypes.oneOf([
        'topFiveEmergingModerateRm',
        'topFiveEmergingMajorRm'
    ])
};

export default EmergingRmsTooltip;
